import { render, staticRenderFns } from "./mbselect.vue?vue&type=template&id=202190c8&scoped=true&"
import script from "./mbselect.vue?vue&type=script&lang=js&"
export * from "./mbselect.vue?vue&type=script&lang=js&"
import style0 from "./mbselect.vue?vue&type=style&index=0&id=202190c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202190c8",
  null
  
)

export default component.exports